import React, { memo, useMemo } from 'react';
import { getContext, Symbols } from 'choerodon-ui/shared';
const MenuContext = getContext(Symbols.MenuContext, {});
const BaseMenuContextProvider = function MenuContextProvider(props) {
    const { children, inlineCollapsed, menuTheme } = props;
    const value = useMemo(() => ({
        inlineCollapsed,
        menuTheme,
    }), [inlineCollapsed, menuTheme]);
    return (React.createElement(MenuContext.Provider, { value: value }, children));
};
BaseMenuContextProvider.displayName = 'MenuContextProvider';
export const MenuContextProvider = memo(BaseMenuContextProvider);
export default MenuContext;
